<template lang="pug">
v-container(fluid)
  v-row(justify="center")
    v-col(cols="12" md="8" lg="6")
      v-card(flat class="tw-p-6 tw-text-center")
        div(class="tw-text-xl tw-font-bold tw-mb-2") {{ notice.heading }}
        p(class="tw-text-blueGray-lighten-1 tw-mb-0") {{ notice.detail }}
</template>
<script>
import { earlyAccessBillingNotice } from '@/features/early-access';

export default {
  data() {
    return {
      notice: earlyAccessBillingNotice,
    };
  },
};
</script>
